<template>
  <div class="container is-centered">
      
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {
  },
  data() {
    return {
      
    };
  },
  created() {
  }
};
</script>

<style scoped lang="scss">

</style>
